import Logger from "classes/Logger"
import { AuthContext, GlobalContext } from "context/context"
import { useContext } from "react"
import { request_post } from "services/OSRM"
import { useCancelToken } from "hooks"
import { TransactionCodeEnum } from "enums/TransactionCodeEnum"
import { IconClock, IconTruck, IconBoxUnpacking, IconCancel } from "theme/common/Icon.styled"
import { IMenu } from "interfaces/IMenu"
import { EShippinggroupStatus } from "enums/shippinggroupEmun"

const UseGetReversaOrders = () => {
  const {
    state: { user },
  } = useContext(AuthContext)
  const { newCancelToken } = useCancelToken()

  const { errorHander } = useContext(GlobalContext)

  const getGroupedStatussesReversaOrders = async () => {
    if (!user?.currentSources) {
      Logger.error("No found source")
      return []
    }

    try {
      const response_reverse_preparation = await request_post(
        "/search/shipping_groups",
        {
          filters: {
            "custom.infoReversa.status": "Pendiente de Preparacion",
            channel: "reversas",
            "source.id": user?.allSources ? undefined : user.currentSources || [],
            shippingType: ["TR"],
          },
        },
        newCancelToken(),
      )
      const reversePreparationTotal = response_reverse_preparation?.data?.message?.total || 0

      const response_pending_pickup = await request_post(
        "/search/shipping_groups",
        {
          filters: {
            "custom.infoReversa.status": "Pendiente de Retiro",
            channel: "reversas",
            "source.id": user?.allSources ? undefined : user.currentSources || [],
            shippingType: ["TR"],
            "currentStatus.tag": ["AWAITING_DELIVERY"],
          },
        },
        newCancelToken(),
      )
      const pendingPickupTotal = response_pending_pickup?.data?.message?.total || 0
      //console.log("PENDING_PICKUP", pendingPickupTotal)

      const response_delivered_system = await request_post(
        "/search/shipping_groups",
        {
          filters: {
            "custom.infoReversa.status": "Recepcionado en Sistema",
            channel: "reversas",
            "source.id": user?.allSources ? undefined : user.currentSources || [],
            shippingType: ["TR"],
            "currentStatus.tag": ["DELIVERED"],
          },
        },
        newCancelToken(),
      )
      const deliveredSystemTotal = response_delivered_system?.data?.message?.total || 0
      //console.log("DELIVERED_SYSTEM", deliveredSystemTotal)

      const response_grouped_states = await request_post(
        "/search/shipping_groups/group",
        {
          filters: {
            // "custom.infoReversa.status": "Pendiente de Preparacion",
            channel: "reversas",
            "source.id": user?.allSources ? undefined : user.currentSources || [],
            shippingType: ["TR"],
            "currentStatus.tag": ["IN_TRANSIT", "DELIVERED", "CANCELED_LOGISTIC"],
          },
          groupBy: {
            "currentStatus.tag": { size: 20 },
          },
        },
        newCancelToken(),
      )

      const groupedTags = response_grouped_states?.data?.message?.["currentStatus.tag"] || []
      const groupedCounts = Array.isArray(groupedTags)
        ? groupedTags.reduce((acc: any, curr: any) => {
          const key = Object.keys(curr)[0]
          acc[key] = curr[key]
          return acc
        }, {})
        : {}

      const reversasOptions: IMenu[] = [
        {
          title: "Preparación de Reversa",
          path: "/order/pending_reversa",
          icon: <IconClock />,
          optionCount: reversePreparationTotal,
          status: EShippinggroupStatus.pending_reversa,
        },
        {
          title: "Pendiente de retiro",
          path: "/order/reversas/pickup_reversa",
          icon: <IconClock />,
          optionCount: pendingPickupTotal,
          status: EShippinggroupStatus.pickup_reversa, // Assuming this exists based on SummaryOptionsData
        },
        {
          title: "En tránsito",
          path: "/order/reversas/transit_reversa", // Using standard transit path but contextual to reversa if filters apply
          icon: <IconTruck />,
          optionCount: groupedCounts["IN_TRANSIT"] || 0,
          status: EShippinggroupStatus.transit_reversa,
        },
        {
          title: "Entregado",
          path: "/order/reversas/delivered_reversa",
          icon: <IconBoxUnpacking />,
          optionCount: groupedCounts["DELIVERED"] || 0,
          status: EShippinggroupStatus.delivered_reversa,
        },
        {
          title: "Recepcionado en sistema",
          path: "/order/reversas/delivered_system_reversa",
          icon: <IconBoxUnpacking />,
          optionCount: deliveredSystemTotal,
          status: EShippinggroupStatus.delivered_system_reversa,
        },
        {
          title: "Cancelado",
          path: "/order/reversas/canceled_reversa",
          icon: <IconCancel />,
          optionCount: groupedCounts["CANCELED_LOGISTIC"] || 0,
          status: EShippinggroupStatus.canceled_reversa,
        },
      ]

      return reversasOptions
    } catch (error: any) {
      if (error.response?.status === TransactionCodeEnum.notFound) {
        return []
      }
      Logger.error(error)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
      return []
    }
  }

  const getCountReversaOrders = async () => {
    if (!user?.currentSources) {
      Logger.error("No found source")
      return objectToReturnCount(0)
    }

    try {
      const response = await request_post(
        "/search/shipping_groups",
        {
          filters: {
            "custom.infoReversa.status": "Pendiente de Preparacion",
            channel: "reversas",
            "source.id": user?.allSources ? undefined : user.currentSources || [],
            shippingType: ["TR"],
          },
        },
        newCancelToken(),
      )
      return objectToReturnCount(response.data.message.total || 0)
    } catch (error: any) {
      if (error.response?.status === TransactionCodeEnum.notFound) {
        return objectToReturnCount(0)
      }
      Logger.error(error)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
      return objectToReturnCount(0)
    }
  }

  const objectToReturnCount = (count: number) => {
    return {
      status: "PENDING_REVERSA",
      count,
    }
  }

  return { getCountReversaOrders, getGroupedStatussesReversaOrders }
}

export default UseGetReversaOrders
